var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.handleClick}},[_c('input',{ref:"input",staticClass:"input-style",attrs:{"accept":_vm.accept,"multiple":_vm.multiple,"type":"file"},on:{"change":_vm.handleChange}}),_vm._t("tip")],2)}
var staticRenderFns = []

export { render, staticRenderFns }